'use client';

import styled from 'styled-components';
export const StyledInstructions = styled.p`
  text-align: center;
  font-size: 18px !important;
  padding-bottom: 20px;

  /* color: grey !important; */
`;
